// 兼容老数据（create-form），强制转换成对应的场景。而不用修改所有的老数据
const _ConvertCompontent = {
  datePicker: 'panguDatePicker',
  DatePicker: 'panguDatePicker',
  datepicker: 'panguDatePicker',
  progress: 'i-progress',
  button: 'i-button',
  switch: 'i-switch',
  Switch: 'i-switch',
  select: 'panguSelect',
  checkbox: 'Checkbox', // wyf 产品维护编辑页面 需要得到Boolean类型而不是复选远程的Array类型
  inputNumber: 'panguInputNumber',
  inputnumber: 'panguInputNumber',
  radio: 'radioRemote',
  input: 'i-input',
  objectjsonedit: 'objectJsonEdit',
  workflowdiagramedit: 'workflowDiagramEdit',
  arrtostr: 'arrToStr',
  grouplabel: 'groupLabel',
}

// 单元格可渲染的组件
const _needRender = [
  'i-input',
  'input',
  'inputNumber',
  'panguInputNumber',
  'inputSelectOfModalTable',
  'panguSelect',
  'selectRemote',
  'TimePicker',
  'panguDatePicker',
  'referencePrice',
]

var dynamicItemUtil = {
  // 是否要单元格渲染组件
  isCellRender(componentName) {
    return _needRender.some((im) => im === componentName)
  },
  // 单元格要显示的文字的转换

  //这里为了让下拉能够正常的返回数据 增加了 resultValue 这个配置  "resultValue": {"0": "0","true": "上架","false": "下架"	}

  initValueTrans(value, resultValue) {
    let resValue
    const setValue = resultValue ? resultValue : { true: '是', false: '否', 0: '0' }
    if (value === null) return '-'
    if (typeof value === 'object') {
      value.hasOwnProperty('name') ? (resValue = value.name) : value
    } else if (setValue[value]) {
      resValue = setValue[value]
    } else {
      resValue = value
    }
    return resValue || '-'
  },
  // 强制转换成对应的场景。而不用修改所有的老数据
  convertComponentName(componentName) {
    if (!componentName) componentName = 'readText'
    return _ConvertCompontent[componentName] || componentName
  },
}

export default dynamicItemUtil
